import { Component, ElementRef, ViewChild, OnDestroy, AfterViewInit, ChangeDetectorRef, OnInit } from '@angular/core';
import { IBluePrintNodeModel } from '../../../../../models/blueprint/blueprint-node.model';
import { IBluePrintModel } from '../../../../../models/blueprint/blueprint.model';
import { IKeyValueMapperModel, KeyValueMapperModel } from '../../../../../models/utility/key-value-mapper.model';
import { PatchNodePayload } from '../../../../../models/node/patch-node-payload.model';
import { BlueprintDataHelper } from '../../../../../services/helpers/blueprint-data.helper';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Helper } from '../../../../../services/helper.service';
import { environment } from '../../../../../../environments/environment';
import { DashboardHelper } from '../../../../../services/dashboard.service';
import { UiStateStore } from '../../../../../services/stores/ui-state.store';
import { BluePrintAPIService } from '../../../../../services/api/blueprint.api.service';
import { LoggerService } from '../../../../../services/logger.service';
import { BlueprintStore } from '../../../../../services/stores/blueprint.store';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseComponent } from '../../../../../components/base/base.component';
import { UserService } from '../../../../../services/user.service';
import { PermissionService } from '../../../../../services/permission.service';

interface Field {
  id: string;
  fieldType: string;
  // other properties if needed
}

@Component({
  selector: 'app-blueprint-node-property',
  templateUrl: './blueprint-node-property.component.html',
  standalone: false,
})
export class BlueprintNodePropertyComponent extends BaseComponent implements AfterViewInit, OnDestroy, OnInit {
  className = 'BlueprintNodePropertyComponent';
  //  we can't create node called 'rootnode', this is reserved key word for WSI top virtual node
  selectedBluePrintNode: IBluePrintNodeModel = {} as IBluePrintNodeModel;
  selectedBluePrintNodeOldVal: IBluePrintNodeModel = {} as IBluePrintNodeModel;
  selectedBluePrint: IBluePrintModel = {} as IBluePrintModel;
  availableFields: Array<IKeyValueMapperModel> = [];
  oldName: string = '';
  nodeShapeList: string[] = [];

  // property binding
  public propertyBindingInputTableData: any[] = [];
  public propertyBindingTableConfig: any[] = [];
  public propertyBindingOutPutTableData: any[] = [];
  formChanged: boolean = false;

  // field allocation
  public fieldAllocationInputTableData: any[] = [];
  public fieldAllocationTableConfig: any[] = [];
  public fieldAllocationOutputTableData: any[] = [];

  public powerNodeList: any[] = [];

  @ViewChild('inputName') inputNameElement!: ElementRef;
  @ViewChild('myForm') myForm!: NgForm;

  constructor(
    private dashboardHelper: DashboardHelper,
    private bluePrintStore: BlueprintStore,
    private bluePrintService: BluePrintAPIService,
    private helperService: Helper,
    private uiStateStore: UiStateStore,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private bluePrintHelper: BlueprintDataHelper,
    private loggerService: LoggerService,
    private userService: UserService,
    private permissionService: PermissionService,
  ) {
    super();
  }

  public get isReadOnly(): boolean {
    if (this.permissionService.isSysAdmin) {
      return false;
    }
    const blueprintOrgId = this.selectedBluePrint?.organizationId?.toLowerCase();
    const userOrgId = this.userService.user?.organizationId?.toLowerCase();
    if (!blueprintOrgId || !userOrgId) {
      // Unknown org on either side - fail closed (read-only) rather than treat two empty/missing
      // org ids as a match.
      return true;
    }
    return blueprintOrgId !== userOrgId;
  }

  ngAfterViewInit() {
    //this.loggerService.traceEnter(this.className, this.ngAfterViewInit.name, '', '');

    const allTasks = [this.route.params, this.bluePrintStore.$selectedBluePrint];
    this.dashboardHelper.setSharedRightPanelHeaderTitle('Node');
    this.subscribers.all = combineLatest(allTasks)
      .pipe(
        map((results: any) => {
          if (!results || results.length !== allTasks.length) {
            return;
          }
          this.selectedBluePrint = results[1];
          //this.loggerService.traceInfo(this.className, this.ngAfterViewInit.name, 'selectedBluePrint', '', this.selectedBluePrint);
          if (this.selectedBluePrint) {
            const node = this.selectedBluePrint.nodes.find((node) => node.id === results[0]['id']);
            if (node) this.bluePrintStore.selectedBluePrintNode = node;
            // this.dashboardHelper.setShowRightPanel(true);
          }
        }),
      )
      .subscribe();

    this.subscribers.rightPanelVisible = this.dashboardHelper.$showRightPanel.subscribe((panelVisibility) => {
      if (panelVisibility === false) {
        // If right side panel is closed without saving then reset to previous value
        if (this.selectedBluePrint && this.selectedBluePrintNodeOldVal) {
          const oldNode = this.selectedBluePrint.nodes.find((n) => n.id === this.selectedBluePrintNodeOldVal.id);
          if (oldNode) this.selectedBluePrint.nodes[this.selectedBluePrint.nodes.indexOf(oldNode)] = this.selectedBluePrintNodeOldVal;
          if ((this.myForm && this.myForm.form.dirty && this.myForm.form.valid) || this.formChanged) {
            this.myForm.form.markAsPristine();
            this.cdr.detectChanges();
          }
        }
      }
    });

    this.subscribers.selectedItemChanged = this.dashboardHelper.selectedItem.subscribe((result) => {
      if (this.selectedBluePrintNode) {
        console.log(result);
        if (result) this.configPowerNodeTypeList(result);
      }

      if (this.selectedBluePrintNode && this.selectedBluePrintNode.id !== result) {
        if ((this.myForm && this.myForm.form.dirty && this.myForm.form.valid) || this.formChanged) {
          this.myForm.form.markAsPristine();
          this.saveWork();
        }
      }
    });

    this.subscribers.bpnode = this.bluePrintStore.$selectedBluePrintNode.subscribe((result) => {
      if (result) {
        // this.loggerService.traceInfo(this.className, this.ngAfterViewInit.name, 'selectedBluePrintNode', '', result);
        this.configPowerNodeTypeList(result.id);

        this.selectedBluePrintNode = result;
        this.selectedBluePrintNodeOldVal = this.helperService.getDeepCopy(result);
        this.propertyBindingInputTableData = [];
        this.propertyBindingOutPutTableData = [];

        this.fieldAllocationInputTableData = [];
        this.fieldAllocationOutputTableData = [];

        // this.selectedBluePrintNode = result;

        if (this.selectedBluePrintNode) {
          this.constructNodeShapeList();

          // this.propertyBindingTableConfig = this.getPropertyBindingTableConfig();
          // if (this.selectedBluePrintNode.propertyBinding) {
          //   this.constructPropertyBindingTableDataWhenLoad();
          // }

          this.availableFields = [];
          if (this.selectedBluePrint) {
            this.selectedBluePrint.fields.forEach((field) => {
              // Load all nodes as source and targets for mapping
              this.availableFields.push(new KeyValueMapperModel(field.id, field.name));
            });
          }

          this.propertyBindingTableConfig = this.getPropertyBindingTableConfig();
          this.fieldAllocationTableConfig = this.getFieldAllocationTableConfig();
          if (this.selectedBluePrintNode.propertyBinding) {
            this.constructPropertyBindingTableDataWhenLoad();
          }
          this.constructFieldAllocationTableDataWhenLoad();

          if (this.selectedBluePrint && this.selectedBluePrintNode.fields) {
            this.availableFields = [];
            this.selectedBluePrint.fields.forEach((field) => {
              // Load all nodes as source and targets for mapping
              this.availableFields.push(new KeyValueMapperModel(field.id, field.name));
            });
          }
          this.oldName = this.selectedBluePrintNode.name;
          this.cdr.detectChanges();
        }
      }
    });
  }

  ngOnInit(): void {}

  configPowerNodeTypeList(nodeId: string) {
    if (nodeId && this.selectedBluePrint && this.selectedBluePrint.nodes) {
      const selectedNode = this.selectedBluePrint.nodes.find((n) => n.id === nodeId);

      if (selectedNode) {
        this.powerNodeList = [];
        this.powerNodeList[0] = { text: 'none', value: 'none' };

        if (selectedNode.powerNodeType === environment.PowerNode.types.etAgileRun.value) {
          this.powerNodeList[1] = {
            text: environment.PowerNode.types.etAgileRun.text,
            value: environment.PowerNode.types.etAgileRun.value,
          };
        }

        const etAgileNode = this.selectedBluePrint.nodes.find((n) => n.powerNodeType === environment.PowerNode.types.etAgileRun.value);

        if (etAgileNode === undefined) {
          this.powerNodeList[1] = {
            text: environment.PowerNode.types.etAgileRun.text,
            value: environment.PowerNode.types.etAgileRun.value,
          };
        }
      }
    }
  }

  nodeTypeChange(event: any) {
    // this.saveWork();
    // if (this.selectedBluePrintNode.powerNodeType === environment.PowerNode.types.etAgileRun.value) {
    //   this.bluePrintService.setAddSpecialNodeTypesInBluePrint(this.selectedBluePrintNode.powerNodeType);
    // }
  }

  ngOnDestroy(): void {
    this.cdr.detach();
    // if (this.subscribers) {
    //   if (this.subscribers.bpnode) {
    //     this.subscribers.bpnode.unsubscribe();
    //   }
    //   if (this.subscribers.rightPanelVisible) {
    //     this.subscribers.rightPanelVisible.unsubscribe();
    //   }
    //   if (this.subscribers.bp) {
    //     this.subscribers.bp.unsubscribe();
    //   }
    //   if (this.subscribers.params) {
    //     this.subscribers.params.unsubscribe();
    //   }
    //   if (this.subscribers.selectedItemChanged) {
    //     this.subscribers.selectedItemChanged.unsubscribe();
    //   }
    // }
  }

  public selectName() {
    const value = this.inputNameElement?.nativeElement?.value?.toLowerCase() ?? '';
    if (value.startsWith('node type')) {
      this.inputNameElement?.nativeElement?.select();
    }
  }

  public saveWork() {
    if (this.isReadOnly) {
      return;
    }
    this.bluePrintHelper.validateName(this.oldName, 'node');

    if (this.selectedBluePrintNode.powerNodeType === environment.PowerNode.types.etAgileRun.value) {
      this.bluePrintStore.addSpecialNodeTypesInBluePrint = this.selectedBluePrintNode.powerNodeType;
    }

    if (this.selectedBluePrintNode.fields !== undefined && this.selectedBluePrintNode.fields !== null && this.selectedBluePrintNode.fields.length > 0) {
      for (const key of Object.keys(this.selectedBluePrintNode.fields)) {
        delete this.selectedBluePrintNode.fields[key]; // delete the existing mapping
        break;
      }
    }

    this.selectedBluePrintNode.fields = this.constructFieldAllocationTableDataWhenSaveToDB();
    this.selectedBluePrintNode.propertyBinding = this.constructPropertyBindTAbleDataWhenSaveToDB();
    this.uiStateStore.startBackendAction('Saving Node...');
    this.oldName = this.selectedBluePrintNode.name;
    this.selectedBluePrintNodeOldVal = this.selectedBluePrintNode; // update latest changes as we save

    // const patchPayload: PatchNodePayload = new PatchNodePayload();
    // patchPayload.bluePrintId = this.selectedBluePrint.id;
    // patchPayload.node = this.selectedBluePrintNode;

    const tempId = this.selectedBluePrintNode.id;
    const tempName = this.selectedBluePrintNode.name;

    this.bluePrintStore.patchNode(this.selectedBluePrintNode, true, '').subscribe((result) => {
      this.myForm.form.markAsPristine();
      this.formChanged = false;
      this.dashboardHelper.setModifiedPropertyItem({
        // update the diagram
        id: tempId,
        name: tempName,
        label: this.selectedBluePrintNode.label,
      });
      this.uiStateStore.endBackendAction('Node Saved!');
      this.cdr.detectChanges();
    });
    // this.uiHelper.closeRightPanel(this.router);
  }

  public onNameBlur() {
    if (this.isReadOnly) {
      return;
    }
    if (this.selectedBluePrintNode.name === '') {
      this.selectedBluePrintNode.name = this.oldName; // revert to old name
      this.dashboardHelper.setModifiedPropertyItem({
        // update the diagram
        id: this.selectedBluePrintNode.id,
        name: this.selectedBluePrintNode.name,
      });
    } else {
      this.bluePrintHelper.validateName(this.oldName, 'node');
      this.oldName = this.selectedBluePrintNode.name;
    }
  }

  public onChange() {
    if (this.isReadOnly) {
      return;
    }
    if (this.selectedBluePrintNode.name === '') {
      return;
    }
    // this.selectedBluePrint.nodes[this.index] = this.selectedBluePrintNode;
    // this.bluePrintService.setSelectedBluePrint(this.selectedBluePrint); // update the modified model back to session
    this.dashboardHelper.setModifiedPropertyItem({
      id: this.selectedBluePrintNode.id,
      name: this.selectedBluePrintNode.name,
    });
  }

  private constructNodeShapeList() {
    this.nodeShapeList = ['Actor', 'Circle', 'Cylinder1', 'Diamond', 'Hexagon', 'Heptagon', 'Octagon', 'Pentagon', 'Rectangle', 'RoundedRectangle', 'TriangleUp'];
  }

  private blueprintNodeFields(): Field[] {
    const selectednodeField: any[] = [];
    if (this.selectedBluePrintNode && this.selectedBluePrint) {
      for (const selectedNodeFieldkey in this.selectedBluePrintNode.fields) {
        for (const selectedBlueprintFieldKey in this.selectedBluePrint.fields) {
          const blueprintFieldId = this.selectedBluePrint.fields[selectedBlueprintFieldKey]?.['id'];
          if (blueprintFieldId && selectedNodeFieldkey && blueprintFieldId.toLowerCase() === selectedNodeFieldkey.toLowerCase()) {
            selectednodeField.push(this.selectedBluePrint.fields[selectedBlueprintFieldKey]);
          }
        }
      }
    }
    return selectednodeField;
  }

  // field allocation
  private getFieldAllocationTableConfig(): any[] {
    return [
      {
        position: 1,
        header: 'Field',
        name: 'field',
        type: 'dropdown',
        options: this.selectedBluePrint?.fields,
      },
      // { position: 2, header: 'Field Label', name: 'fieldLabel', type: 'text' }
    ];
  }

  public onGetFieldAllocationTableDataOutput(data: any) {
    if (this.isReadOnly) {
      return;
    }
    if (data) {
      // The deleted field mappings are deleted from property binding if found
      this.formChanged = true;
      this.fieldAllocationOutputTableData = data;
      this.fieldAllocationInputTableData = data;
      this.selectedBluePrintNode.fields = this.constructFieldAllocationTableDataWhenSaveToDB();
      this.propertyBindingTableConfig = this.getPropertyBindingTableConfig();

      // Remove the deleted fields from property binding when filed mapping is changed
      if (this.selectedBluePrintNode.propertyBinding !== null) {
        this.selectedBluePrintNode.propertyBinding.forEach((pb: any) => {
          const propertyFoundInFields = data.find((d: any) => d.field.id === pb.targetFieldId);
          if (!propertyFoundInFields) {
            this.selectedBluePrintNode.propertyBinding.splice(this.selectedBluePrintNode.propertyBinding.indexOf(pb), 1);
          }
        });

        // Reconstruct propertybinding table data
        if (this.selectedBluePrintNode.propertyBinding) {
          this.constructPropertyBindingTableDataWhenLoad();
        }
      }
    }
  }

  private constructFieldAllocationTableDataWhenLoad() {
    // this function implementation will change with proper implementation
    const fieldAllocationDataFromDB = this.selectedBluePrintNode?.fields;
    const fieldAllocationNewArray = [];

    for (const key in fieldAllocationDataFromDB) {
      if (fieldAllocationDataFromDB.hasOwnProperty(key)) {
        const newFieldRow: any = {};
        newFieldRow['position'] = fieldAllocationDataFromDB[key];
        // newFieldRow['fieldLabel'] = ''; // dummy value
        if (this.selectedBluePrint && this.selectedBluePrint.fields) {
          const field = this.selectedBluePrint.fields.find((f) => f.id === key);
          if (field) {
            newFieldRow['field'] = field;
          }
          fieldAllocationNewArray.push(newFieldRow);
        }
      }
    }
    this.fieldAllocationInputTableData = fieldAllocationNewArray;
    this.fieldAllocationOutputTableData = fieldAllocationNewArray;
  }

  private constructFieldAllocationTableDataWhenSaveToDB(): {} {
    // temporary implementation
    const dictionary: any = {};
    const tableData = this.removeCatchIndexAndAddPositionToFieldAllocationTableData();

    if (tableData.length > 0) {
      tableData.forEach((fieldRow) => {
        dictionary[fieldRow['field']['id']] = fieldRow['position'];
      });
    }
    return dictionary;

    // proper implementation will complete in future this one need change in API
    // const fieldAllocationArray = [];

    // const tableData = this.removeCatchIndexAndAddPositionToFieldAllocationTableData();
    // if (tableData.length > 0) {

    //   tableData.forEach(fieldRow => {

    //     const fieldAllocation = {};
    //     fieldAllocation['fieldId'] = fieldRow['field']['id'];
    //     fieldAllocation['fieldLabel'] = fieldRow['fieldLabel'];
    //     fieldAllocation['position'] = fieldRow['position'];
    //     fieldAllocationArray.push(fieldAllocation);

    //   });
    // }
    // return fieldAllocationArray;
  }

  private removeCatchIndexAndAddPositionToFieldAllocationTableData() {
    const tableDataWithPosition: any[] = [];
    let position = 1;

    if (this.fieldAllocationOutputTableData) {
      this.fieldAllocationOutputTableData.forEach((row) => {
        row['position'] = position;
        ++position;
        const copy = this.helperService.getDeepCopy(row);
        delete copy['catchindex'];
        tableDataWithPosition.push(copy);
      });
    }
    return tableDataWithPosition;
  }

  private constructPropertyBindingTableDataWhenLoad() {
    const propertyBindingDataFromDB: any[] = this.selectedBluePrintNode.propertyBinding;
    const propertyBindingNewArray: any[] = [];

    propertyBindingDataFromDB.forEach((propertyBindRow) => {
      const newColorDataRow: any = {};
      const newColorValueList: any[] = [];

      // 1. Split and clean the data
      const colorDataRow = propertyBindRow['colorData'] || '';
      const colorValueDataList = colorDataRow.split('\n').filter((x: string) => x.trim() !== '');

      colorValueDataList.forEach((row: string) => {
        const colorValueData: any = {};
        const parts = row.split(':');
        colorValueData['value'] = parts[0];
        colorValueData['color'] = parts[1];
        newColorValueList.push(colorValueData);
      });

      // 2. APPLY SMART SORT
      // If it's Priority, sort so P1 is at Index 0.
      // If it's Epic Status, leave it alone so 'To Do' stays at Index 0.
      if (propertyBindRow['bindingName'].toLowerCase() === 'priority') {
        newColorValueList.sort((a, b) => {
          // Extracts the number from 'P1', 'P2' etc. and sorts 1 to 5
          const numA = parseInt(a.value.replace(/\D/g, '')) || 0;
          const numB = parseInt(b.value.replace(/\D/g, '')) || 0;
          return numA - numB;
        });
      }

      newColorDataRow['bindingName'] = propertyBindRow['bindingName'];
      newColorDataRow['defaultColor'] = propertyBindRow['defaultColor'];
      newColorDataRow['shape'] = { name: propertyBindRow['shape'] };
      newColorDataRow['colorData'] = newColorValueList;

      if (this.selectedBluePrint) {
        const field = this.selectedBluePrint.fields.find((f) => f.id === propertyBindRow['targetFieldId']);
        if (field) {
          newColorDataRow['targetField'] = field;
        }
        propertyBindingNewArray.push(newColorDataRow);
      }
    });

    this.propertyBindingInputTableData = propertyBindingNewArray;
    this.propertyBindingOutPutTableData = propertyBindingNewArray;
  }

  private constructPropertyBindTAbleDataWhenSaveToDB(): any[] {
    const proprtyBindingArray: any[] = [];

    const tableData = this.removeCatchIndexAndAddPositionToPropertyBindingTableData();
    if (tableData.length > 0) {
      tableData.forEach((bindingRow) => {
        const nodeExistInFieldsMapping = this.fieldAllocationOutputTableData.find((fd) => fd.field.id === bindingRow['targetField']['id']);
        if (nodeExistInFieldsMapping) {
          if (this.selectedBluePrintNode.fields[bindingRow['targetField']['id']]) {
            const propertBind: any = {};
            propertBind['bindingName'] = bindingRow['bindingName'];
            propertBind['defaultColor'] = bindingRow['defaultColor'];
            propertBind['position'] = bindingRow['position'];
            propertBind['targetFieldId'] = bindingRow['targetField']['id'];
            propertBind['shape'] = bindingRow['shape']['name'];

            const colorData = bindingRow['colorData'];
            let colorDataText = '';

            colorData.forEach((color: any) => {
              colorDataText += color['value'] + ':' + color['color'] + '\n';
            });

            propertBind['colorData'] = colorDataText;
            proprtyBindingArray.push(propertBind);
          }
        }
      });
    }
    return proprtyBindingArray;
  }

  private getPropertyBindingTableConfig(): any[] {
    const fieldListForNode = this.blueprintNodeFields();
    const filterFiledListforNode = [];

    if (fieldListForNode) {
      for (const key in fieldListForNode) {
        const fieldType = fieldListForNode[key]?.['fieldType'];
        if (fieldType && (fieldType.toLowerCase() === 'dropdownsingle'.toLowerCase() || fieldType.toLowerCase() === 'checkbox'.toLowerCase())) {
          filterFiledListforNode.push(fieldListForNode[key]);
        }
      }
    }

    return [
      {
        position: 1,
        header: 'Binding Name',
        name: 'bindingName',
        type: 'text',
      },
      {
        position: 2,
        header: 'Target Field',
        name: 'targetField',
        type: 'dropdown',
        options: filterFiledListforNode,
      },
      {
        position: 3,
        header: 'Shape',
        name: 'shape',
        type: 'dropdown',
        options: ['Circle', 'Rectangle', 'Octogon', 'Heart'],
      },
      {
        position: 4,
        header: 'Default Colour',
        name: 'defaultColor',
        type: 'color',
      },
    ];
  }

  public onGetPropertyBindingTableDataOutput(data: any) {
    if (this.isReadOnly) {
      return;
    }
    if (data) {
      this.formChanged = true;
      this.propertyBindingOutPutTableData = data;
      this.propertyBindingInputTableData = data;
    }
  }

  private removeCatchIndexAndAddPositionToPropertyBindingTableData() {
    const tableDataWithPosition: any[] = [];
    let position = 1;

    if (this.propertyBindingOutPutTableData) {
      this.propertyBindingOutPutTableData.forEach((row: any) => {
        row['position'] = position;
        ++position;
        const copy = this.helperService.getDeepCopy(row);
        delete copy['catchindex'];
        tableDataWithPosition.push(copy);
      });
    }
    return tableDataWithPosition;
  }
}
